import PropTypes from 'prop-types';

export const functionWithForwardRef = (props, propName) => {
  if (!props[propName] || typeof (props[propName].render) !== 'function') {
    return new Error(`${propName}.render must be a function!`);
  }
  return true;
};

export const renderableType = PropTypes.oneOfType([
  PropTypes.node, PropTypes.func, functionWithForwardRef,
]);

